<template>
<div class="wrld-simple-input">
    <label :class="{'focused': isFocused}" v-show="isFocused || value != null" :for="inputID">{{ label }}</label>
    <input
      :ref="inputID"
      @focus="handleFocus"
      @blur="handleBlur"
      :id="inputID"
      :placeholder="isFocused ? null : label"
      :value="value"
      @input="handleInput"
      @keyup.enter="handleKeyUpEnter"
    />
</div>
</template>

<script>
import { uuid } from 'vue-uuid'
export default {
  name: 'WrldSimpleInput',
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' }
  },
  data () {
    return {
      inputID: uuid.v1(),
      isFocused: false
    }
  },
  methods: {
    handleInput () {
      this.$emit('input', this.$refs[this.inputID].value)
    },
    handleFocus () {
      // this.isFocused = true
    },
    handleBlur () {
      // this.isFocused = false
    },
    handleKeyUpEnter () {
      this.$emit('enter')
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrld-simple-input {
    position: relative;
    label {
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
      cursor: pointer;
      line-height: 2px;
      font-size: 10px;
      background-color: white;
      color: #c5c5c5;
      &.focused {
        color: #484848;
      }
      transition: 300ms cubic-bezier(0.4, 0, 0.2, 1);
      -webkit-transition: 300ms cubic-bezier(0.4, 0, 0.2, 1);
      -ms-transition: 300ms cubic-bezier(0.4, 0, 0.2, 1);
    }
    input {
      border: 1px solid #c5c5c5;
      border-radius: 5px;
      padding: 0 5px;
      margin-bottom: 5px;
      width: 80%;
      font-weight: 500;
      color: #484848;
      &::placeholder {
        color: #c5c5c5;
      }
      &:focus {
        border-color: #484848;
        outline: none;
      }
    }
  }
</style>
